// extracted by mini-css-extract-plugin
export default {"Subheading":"Subheading_Subheading__1MXqs","Subheading_big":"Subheading_Subheading_big__3ONIK"};